import { render, staticRenderFns } from "./MailIframe.vue?vue&type=template&id=e6d45fea&"
import script from "./MailIframe.vue?vue&type=script&lang=ts&"
export * from "./MailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports